//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StockKittingToolNotAllowedIcon from './StockKittingToolNotAllowedIcon.vue'
import StockKittingToolAmountExceededIcon from './StockKittingToolAmountExceededIcon.vue'
import StockKittingToolReserve from '../StockTools/StockKittingToolReserve.vue'

export default {
  components: {
    StockKittingToolNotAllowedIcon,
    StockKittingToolAmountExceededIcon,
    StockKittingToolReserve
  },
  props: {
    manager: {
      type: Object,
      required: true
    },
    tools: {
      type: Array,
      default: function () {
        return []
      }
    },
    state: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 10,
        sortBy: '',
        descending: false
      }
    }
  },
  computed: {
    isMobileDevice: function () {
      const isMobile = this.$store.getters.getUser.view === 'mobile'
      return isMobile
    },
    columns: function () {
      const columns = [
        {
          name: 'toolName',
          label: 'Наименование материала',
          align: 'left',
          field: 'toolName',
          sortable: true,
          getTdStyle: this.getToolTdStyle
        },
        {
          name: 'stockName',
          label: 'Наименование склада-источника',
          align: 'left',
          field: 'stockName',
          sortable: true,
          getTdStyle: this.getStockTdStyle
        },
        {
          name: 'amount',
          label: 'Заказано',
          align: 'left',
          field: 'amount',
          sortable: true,
          getTdStyle: this.getAmountTdStyle
        }
      ]
      if (this.state === 'SK4' || this.state === 'SK5') {
        columns.push({
          name: 'amountIssued',
          label: 'Выдано',
          align: 'left',
          field: 'amountIssued',
          sortable: true
        })
      }
      if (this.state === 'SK5') {
        columns.push({
          name: 'note',
          label: 'Замечания склада',
          align: 'left',
          field: 'note',
          sortable: true
        })
      } else {
        columns.push({
          name: 'amountStock',
          label: 'Остаток на складе-источнике',
          align: 'left',
          field: 'amountStock',
          sortable: true
        })
        columns.push({
          name: 'amountFree',
          label: 'Свободно на складе-источнике',
          align: 'left',
          field: 'amountFree',
          sortable: true
        })
      }
      if (this.state !== 'SK5' && this.state !== 'SK7') {
        columns.push({
          name: 'targetStockAmount',
          label: 'Текущий остаток на складе-получателе',
          align: 'left',
          field: 'targetStockAmount',
          sortable: true
        })
        if (this.manager && this.manager.request && this.manager.request.stock && this.manager.request.stock.id) {
          columns.push({
            name: 'otherAgreedRequests',
            label: 'Заказано по другим заявкам на выбранный склад-получатель',
            align: 'left',
            field: 'otherRequestsRecords',
            sortable: true
          })
        }
      }
      if (this.state === 'SK5' || this.state === 'SK7') {
        columns.push({
          name: 'targetStockAmountReadyAgreed',
          label: 'Остаток на складе-получателе при заказе',
          align: 'left',
          field: row => (row.targetStockAmountReady || 0) + '/' + (row.targetStockAmountAgreed || 0),
          sortable: true
        })
      }
      return columns
    }
  },
  methods: {
    onOpenRecord: function (row) {
      this.$emit('open-tool', row)
    },
    onRemoveRecord: function (toolId) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.onRemove(toolId)
          }
        },
        warning: 'Удалить материал из заявки?',
        buttons: [
          { key: 'yes', name: 'Да', color: 'red' },
          { key: 'no', name: 'Нет', color: 'blue' }
        ]
      })
    },
    onRemove: function (toolId) {
      this.$emit('remove-tool', toolId)
    },
    isInt: function (unit) {
      return ['упак', 'бут', 'пар', 'компл', 'рул', 'мешок', 'лист', 'усл. шт', 'шт'].includes(unit)
    },
    getTextAmount: function (unit, amount) {
      if (this.isInt(unit)) {
        const partFloat = String(amount).split('.')[1] ? String(amount).split('.')[1] : 0
        const txtAmount = parseInt(amount) || 0
        return partFloat ? parseFloat(amount).toFixed(3) : txtAmount
      } else {
        return amount ? parseFloat(amount).toFixed(3) : 0.000
      }
    },
    getStockTdStyle: function (toolRecord) {
      if (this.manager.isStockNotAllowed(toolRecord)) {
        return 'background-color: #ffcece !important;'
      }
      return null
    },
    getToolTdStyle: function (toolRecord) {
      if (this.manager.isToolNotAllowed(toolRecord)) {
        return 'background-color: #ffcece !important;'
      }
      return null
    },
    getAmountTdStyle: function (toolRecord) {
      if (this.state !== 'SK5' && this.manager.isToolAmountExceeded(toolRecord)) {
        if (this.manager.ignoreLimits) {
          return 'background-color: #ffe0b2 !important;' // orange-2 ( orange-4 = #ffb74d )
        } else {
          return 'background-color: #ffcece !important;' // red-?
        }
      }
      return null
    }
  }
}
